export var PREFIX_CLS = 'ant-fullcalendar';


//////////////////
// WEBPACK FOOTER
// /Users/jim/Documents/GitHub/ant-design-pro-site/scaffold/node_modules/_antd@3.6.4@antd/es/calendar/Constants.js
// module id = null
// module chunks = 